import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { ModalSizeEnum } from 'src/app/model/generic-modal-confirm.model';
import { AlertManagerService } from '../alert/alert.manager.service';
import { ModalManagerService } from '../modal/modal-manager.service';

export enum MessageManagerTypeEnum {
  MODAL_MESSAGE = '1',
  ALERT_MESSAGE = '2',
}

export enum MessageManagerMessageTypeEnum {
  INFO = 'INFO',
  WARNING = 'WARNING',
  DANGER = 'DANGER',
  SUCCESS = 'SUCCESS',
  CONFIRM = 'CONFIRM',
}

export interface IMessageManager {
  type: MessageManagerTypeEnum;
  msgType: MessageManagerMessageTypeEnum;
  title: string;
  message: string;
  multiMessage: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MessageManagerService {
  private _messages: IMessageManager[] = [];
  set messages(msg: any) {
    if (this._messages.length == 0) {
      this.executeMessage(msg);
    }
    this._messages.push(msg);
  }
  get messages(): IMessageManager[] {
    return this._messages;
  }

  constructor(
    private modalManager: ModalManagerService,
    private alertManager: AlertManagerService
  ) {
    combineLatest([
      this.modalManager.notifyClosingModal,
      this.alertManager.notifyClosingAlert,
    ]).subscribe((closed) => {
      if (closed) {
        this._messages.shift();
        if (this._messages.length > 0) {
          this.executeMessage(this.messages[0]);
        }
      }
    });
  }

  addMessage(msg: IMessageManager) {
    this.messages = msg;
  }

  executeMessage(msg: IMessageManager) {
    if (msg.type == MessageManagerTypeEnum.MODAL_MESSAGE) {
      this.modalManager.createOpenTextModal(
        msg.title,
        msg.message,
        MessageManagerMessageTypeEnum.DANGER,
        undefined,
        msg.multiMessage,
        true,
        ModalSizeEnum.GRANDE,
        false,
        true,
        false
      );
    } else if (msg.type == MessageManagerTypeEnum.ALERT_MESSAGE) {
      this.alertManager.createAlert(
        msg.message,
        '',
        MessageManagerMessageTypeEnum.DANGER,
        undefined,
        '',
        msg.multiMessage,
        true,
        120000,
        false,
        false
      );
    }
  }
}
